(() => {
  const initQuiz = (quiz) => {
    if (quiz.dataset.ready === 'true') return;
    quiz.dataset.ready = 'true';

    const form = quiz.querySelector('[data-quiz-form]');
    const steps = Array.from(quiz.querySelectorAll('[data-quiz-step]'));
    const progress = Array.from(quiz.querySelectorAll('[data-quiz-progress] span'));
    const error = quiz.querySelector('[data-quiz-error]');
    const result = quiz.querySelector('[data-quiz-result]');
    const resultName = quiz.querySelector('[data-result-name]');
    const resultReason = quiz.querySelector('[data-result-reason]');
    const resultLink = quiz.querySelector('[data-result-link]');
    const officeLink = quiz.querySelector('[data-office-link]');
    const root = quiz.dataset.root || '/';
    let currentStep = 0;

    const path = (value) => `${root}${value}`.replace(/\/\/{2,}/g, '/');

    const showStep = (index) => {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== currentStep;
      });
      progress.forEach((item, progressIndex) => {
        item.classList.toggle('is-current', progressIndex === currentStep);
        item.classList.toggle('is-complete', progressIndex < currentStep);
      });
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
      steps[currentStep]?.querySelector('legend')?.focus?.();
    };

    const selectedValue = (name) => form.querySelector(`input[name="${name}"]:checked`)?.value || '';

    const recommendation = () => {
      const method = selectedValue('brew_method');
      const flavor = selectedValue('flavor');
      const intensity = selectedValue('intensity');
      const moment = selectedValue('moment');
      let choice;

      if (method === 'arabic') {
        choice = {
          name: 'Arabic Coffee',
          url: path('products/arabic-coffee-250-gm-copy'),
          reason: 'اختيار مناسب للقهوة العربية بطابع عطري واضح وتحضير الضيافة التقليدي.',
        };
      } else if (method === 'espresso') {
        choice = {
          name: 'Espresso Beans',
          url: path('collections/espresso'),
          reason: 'حبوب إسبريسو تمنحك قواماً ثابتاً وكريما أوضح مع الماكينة أو الموكا بوت.',
        };
      } else if (method === 'filter') {
        choice = {
          name: 'Your Mix',
          url: path('collections/your-mix'),
          reason: 'تشكيلة مرنة تساعدك على اختيار النكهة والحدة الأنسب للتحضير الهادئ أو الفرنسي.',
        };
      } else if (flavor === 'flavored') {
        choice = {
          name: 'Hazelnut Coffee',
          url: path('products/hazelnut-coffee-100-gm-copy'),
          reason: 'نكهة بندق واضحة وحلوة بدون أن تفقد شخصية القهوة الأساسية.',
        };
      } else if (flavor === 'cardamom' && intensity === 'light') {
        choice = {
          name: 'Special Turkish Coffee Light With Cardamom',
          url: path('products/light-roast-turkish-coffee-with-cardamom-250gm'),
          reason: 'تحميص فاتح مع هيل؛ عطري وخفيف ومناسب لبداية اليوم.',
        };
      } else if (flavor === 'cardamom') {
        choice = {
          name: 'Special Turkish Coffee Medium With Cardamom',
          url: path('products/medium-roast-turkish-coffee-with-cardamom-250gm'),
          reason: 'توازن بين جسم القهوة ووضوح الهيل مع تحميص متوسط.',
        };
      } else if (intensity === 'light') {
        choice = {
          name: 'Special Turkish Coffee Light Plain',
          url: path('products/light-roast-turkish-coffee-with-cardamom-250gm-copy'),
          reason: 'تحميص فاتح سادة بطعم أنعم ومرارة أقل.',
        };
      } else {
        choice = {
          name: 'Special Turkish Coffee Medium Plain',
          url: path('products/medium-roast-turkish-coffee-250gm'),
          reason: 'قهوة تركي سادة متوازنة بجسم أوضح وتحميص متوسط.',
        };
      }

      choice.office = moment === 'office';
      return choice;
    };

    form.addEventListener('click', (event) => {
      const next = event.target.closest('[data-quiz-next]');
      const previous = event.target.closest('[data-quiz-previous]');
      if (previous) {
        showStep(currentStep - 1);
        return;
      }
      if (!next) return;
      const checked = steps[currentStep].querySelector('input:checked');
      if (!checked) {
        if (error) {
          error.hidden = false;
          error.textContent = 'اختر إجابة واحدة للمتابعة.';
        }
        return;
      }
      showStep(currentStep + 1);
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const checked = steps[currentStep].querySelector('input:checked');
      if (!checked) {
        if (error) {
          error.hidden = false;
          error.textContent = 'اختر إجابة واحدة لعرض النتيجة.';
        }
        return;
      }
      const choice = recommendation();
      form.hidden = true;
      result.hidden = false;
      resultName.textContent = choice.name;
      resultReason.textContent = choice.reason;
      resultLink.href = choice.url;
      officeLink.hidden = !choice.office;
      result.querySelector('h2')?.focus?.();
    });

    quiz.querySelector('[data-quiz-restart]')?.addEventListener('click', () => {
      form.reset();
      form.hidden = false;
      result.hidden = true;
      showStep(0);
    });

    showStep(0);
  };

  const initAll = () => document.querySelectorAll('[data-shams-quiz]').forEach(initQuiz);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
